import { render, staticRenderFns } from "./QuestionTemplateStatusesEditForm.vue?vue&type=template&id=548ee470&scoped=true&"
import script from "./QuestionTemplateStatusesEditForm.vue?vue&type=script&lang=ts&"
export * from "./QuestionTemplateStatusesEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionTemplateStatusesEditForm.vue?vue&type=style&index=0&id=548ee470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ee470",
  null
  
)

export default component.exports